import { useEffect } from "react";

const ThemeToggle = () => {
  const applyTheme = (theme) => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  };

  const getStoredTheme = () => {
    return localStorage.getItem("theme") ||
      (window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light");
  };

  const toggleTheme = () => {
    const current = getStoredTheme();
    const next = current === "dark" ? "light" : "dark";
    applyTheme(next);
    updateToggleButton(next);
  };

  const updateToggleButton = (theme = getStoredTheme()) => {
    const textEl = document.getElementById("theme-toggle-text");
    const lightIcon = document.getElementById("theme-icon-light");
    const darkIcon = document.getElementById("theme-icon-dark");

    if (textEl && lightIcon && darkIcon) {
      // textEl.textContent = theme === "dark" ? "Light Mode" : "Dark Mode";
      lightIcon.style.display = theme === "dark" ? "none" : "inline";
      darkIcon.style.display = theme === "dark" ? "inline" : "none";
    }
  };

  useEffect(() => {
    const theme = getStoredTheme();
    applyTheme(theme);
    updateToggleButton(theme);
  }, []);

  return (
    <>
      <button id="theme-toggle" aria-label="Toggle dark mode" onClick={toggleTheme}>
      <span id="theme-icon-light"><i className="fa-solid fa-sun"></i></span>
      <span id="theme-icon-dark"><i className="fa-solid fa-moon"></i></span>
      </button>
    </>
  );
};

export default ThemeToggle;
